import React from 'react';
import * as S from './HorizontalLine.styles'
export const HorizontalLine = ({data}) =>{
    return (<S.HorizontalLine>
    {data?.primaryText && <span className="orText">
        {data?.primaryText}
    </span>}
</S.HorizontalLine>)
}